<template lang="pug">
.invoice-payments-styled-panel
  //- Header con título y contador
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      .tw-w-10.tw-h-10.tw-rounded-lg.tw-bg-emerald-100.tw-flex.tw-items-center.tw-justify-center
        i.fa-solid.fa-credit-card.tw-text-emerald-600.tw-text-lg
      div
        span.tw-font-semibold.tw-text-gray-700 Payments
        span.tw-bg-emerald-100.tw-text-emerald-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium.tw-ml-2
          | {{ items.length }}
  
  //- Leyenda de columnas
  .tw-flex.tw-items-center.tw-gap-4.tw-mb-3.tw-text-xs(v-if='!emptyItems')
    span.tw-text-gray-500 Column Groups:
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-gray-200
      span.tw-text-gray-600 Payment Info
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-green-200
      span.tw-text-gray-600 Amount
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-blue-200
      span.tw-text-gray-600 Method Details
  
  //- Tabla mejorada
  table(v-if='!emptyItems' class="table table-hover invoice-payments-styled-table")
    thead.tw-bg-gray-50
      tr
        th.tw-text-center.tw-bg-gray-100(style="border-left: 2px solid #e5e7eb;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-hashtag.tw-text-gray-400.tw-text-xs
            span ID
        th.tw-text-center.tw-bg-gray-100
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-flag.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.invoice_payments_table_panel.table_header_status')}}
        th.tw-text-center.tw-bg-gray-100(style="border-right: 2px solid #e5e7eb;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-calendar.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.invoice_payments_table_panel.table_header_date_payment')}}
        //- Amount
        th.tw-text-center.tw-bg-green-50(style="border-left: 2px solid #bbf7d0; border-right: 2px solid #bbf7d0;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-dollar-sign.tw-text-green-500.tw-text-xs
            span {{$I18n.t('vue.invoice_payments_table_panel.table_header_amount_paid')}}
        //- Method details
        th.tw-text-center.tw-bg-blue-50(style="border-left: 2px solid #bfdbfe;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-wallet.tw-text-blue-500.tw-text-xs
            span {{$I18n.t('vue.invoice_payments_table_panel.table_header_way_to_pay')}}
        th.tw-text-center.tw-bg-blue-50
          span Check #
        th.tw-text-center.tw-bg-blue-50
          span Card #
        th.tw-text-center.tw-bg-blue-50(style="border-right: 2px solid #bfdbfe;")
          span {{$I18n.t('vue.invoice_payments_table_panel.table_header_reference')}}
        th.tw-text-center.tw-w-16
    tbody
      tr(v-for="item in items" :key="item.id" :class="getRowClass(item)")
        //- Payment info
        td.tw-text-center.tw-bg-gray-50.tw-bg-opacity-50
          a.tw-font-mono.tw-text-blue-600.tw-text-sm.tw-font-medium(:href="payment_path(item.id)" target="_blank")
            | {{item.id}}
        td.tw-text-center.tw-bg-gray-50.tw-bg-opacity-50
          span.tw-inline-flex.tw-items-center.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-font-medium(:class="getStatusBadgeClass(item.status)")
            i.tw-mr-1(:class="getStatusIcon(item.status)")
            | {{$I18n.t('vue.states.'+item.status.toLowerCase())}}
        td.tw-text-center.tw-bg-gray-50.tw-bg-opacity-50
          span.tw-text-gray-700.tw-text-sm {{item.locale_date_payment}}
        //- Amount
        td.tw-text-center.tw-bg-green-50.tw-bg-opacity-50
          span.tw-font-bold.tw-text-green-700 {{item.masked_amount_payment}}
        //- Method details
        td.tw-text-center.tw-bg-blue-50.tw-bg-opacity-50
          span.tw-inline-flex.tw-items-center.tw-px-2.tw-py-1.tw-bg-blue-100.tw-text-blue-700.tw-rounded.tw-text-xs
            i.tw-mr-1(:class="getPaymentMethodIcon(item.way_to_pay)")
            | {{$I18n.t('vue.payment_types.'+item.way_to_pay.split(' ').join('_').toLowerCase())}}
        td.tw-text-center.tw-bg-blue-50.tw-bg-opacity-50
          span.tw-font-mono.tw-text-gray-600.tw-text-sm(v-if="item.num_check") {{item.num_check}}
          span.tw-text-gray-400(v-else) —
        td.tw-text-center.tw-bg-blue-50.tw-bg-opacity-50
          span.tw-font-mono.tw-text-gray-600.tw-text-sm(v-if="item.credit_card_number") ****{{item.credit_card_number.slice(-4)}}
          span.tw-text-gray-400(v-else) —
        td.tw-text-center.tw-bg-blue-50.tw-bg-opacity-50
          span.tw-text-gray-600.tw-text-sm(v-if="item.reference") {{item.reference}}
          span.tw-text-gray-400(v-else) —
        td.tw-text-center
          a.tw-text-blue-600.hover_tw-text-blue-800(:href="payment_path(item.id)" target="_blank" :title="$I18n.t('vue.invoice_payments_table_panel.view_payment')")
            i.fa-solid.fa-external-link
  
  //- Total
  .tw-flex.justify-content-end.tw-mt-3(v-if='!emptyItems')
    .tw-bg-emerald-50.tw-border.tw-border-emerald-200.tw-rounded-lg.tw-px-4.tw-py-2
      .d-flex.align-items-center.tw-gap-3
        span.tw-text-gray-600.tw-text-sm {{$I18n.t('vue.invoice_payments_table_panel.total_payments')}}
        span.tw-font-bold.tw-text-emerald-700.tw-text-lg {{calcularTotal()}}

  //- Empty state
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-emerald-100.tw-rounded-full.tw-flex.tw-items-center.tw-justify-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-credit-card.tw-text-emerald-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{$I18n.t('vue.invoice_payments_table_panel.empty_items')}}

</template>
<script>
import CoreComponents from "../core";
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';
const { BackendRoutes } = require("app/services");
export default {
  mixins: [StickyTableMixin],
  components:{
    "app-icon-link": CoreComponents.AppIconLink,
  },
  props:{
    dataItems: String,
  },
  data: function(){
    return {
      record:{
      },
      items: JSON.parse(this.dataItems),
      labels:{
      }
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    getRowClass: function(item) {
      if (item.status === 'CANCELED') return 'tw-bg-red-50 tw-bg-opacity-50';
      if (item.status === 'APPLIED') return 'tw-bg-green-50 tw-bg-opacity-30';
      return '';
    },
    getStatusBadgeClass: function(status) {
      const statusMap = {
        'APPLIED': 'tw-bg-green-100 tw-text-green-700',
        'CANCELED': 'tw-bg-red-100 tw-text-red-700',
        'PENDING': 'tw-bg-amber-100 tw-text-amber-700',
        'REGISTERED': 'tw-bg-blue-100 tw-text-blue-700',
      };
      return statusMap[status.toUpperCase()] || 'tw-bg-gray-100 tw-text-gray-700';
    },
    getStatusIcon: function(status) {
      const iconMap = {
        'APPLIED': 'fa-solid fa-check-circle',
        'CANCELED': 'fa-solid fa-times-circle',
        'PENDING': 'fa-solid fa-clock',
        'REGISTERED': 'fa-solid fa-file-alt',
      };
      return iconMap[status.toUpperCase()] || 'fa-solid fa-circle';
    },
    getPaymentMethodIcon: function(method) {
      const methodLower = method.toLowerCase();
      if (methodLower.includes('check')) return 'fa-solid fa-money-check';
      if (methodLower.includes('card') || methodLower.includes('credit')) return 'fa-solid fa-credit-card';
      if (methodLower.includes('cash')) return 'fa-solid fa-money-bill';
      if (methodLower.includes('transfer') || methodLower.includes('ach')) return 'fa-solid fa-building-columns';
      return 'fa-solid fa-wallet';
    },
    payment_path: function (payment_id) {
      return BackendRoutes.payment_path(payment_id);
    },
    calcularTotal:function(){
      // Usamos reduce para iterar sobre el array y sumar los precios
      let total = this.items.reduce((total, item) => {
        // Verificamos si el estado del elemento es diferente de "CANCELED"
        if (item.status !== "CANCELED") {
          // Si es diferente, sumamos su precio al total
          return total + parseFloat(item.amount_paid.replace("$", "").replace(",", "").replace(" ", ""));
        } else {
          // Si es "CANCELED", simplemente retornamos el total sin modificarlo
          return total;
        }
      }, 0); // Inicializamos el total en 0
      return total.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },
    state_style_text:function(status){
      let style = "text-black"
      if (status == "CANCELED"){
        style = "text-danger"
      }
      if (status == "APPLIED"){
        style = "text-success"
      }
      return style
    },
  }
}
</script>

<style scoped>
.invoice-payments-styled-panel {
  padding: 0.5rem;
}

.invoice-payments-styled-table {
  font-size: 0.8rem;
}

.invoice-payments-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.5rem;
  font-weight: 600;
  color: #4b5563;
  font-size: 0.75rem;
}

.invoice-payments-styled-table tbody td {
  vertical-align: middle;
  padding: 0.4rem 0.5rem;
}

.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}

.tw-bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}

.hover_tw-text-blue-800:hover {
  color: #1e40af;
}
</style>
